module.exports = __webpack_public_path__ + "static/media/step_3.b26b23a2.png";